<template>
  <div class="app-container">
    <!-- <Carousel :items="carouselItems" /> -->
    <Grid :items="aiItems" />
    <!-- <Grid :items="gridItems" /> -->
  </div>
</template>

<script>
import { ref } from "vue";
import Grid from "../../components/Grid/Grid.vue";
import { FILE_BASE_URL } from "../../api/baseUrl";

export default {
  components: { Grid },
  setup() {
    const aiItems = ref([
      {
        url: `${FILE_BASE_URL}/static/12.jpeg`,
        title: "医生端",
        content: "医生辅助患者填写病情及上传资料",
        link: "/doctorregister",
      },

      {
        url: `${FILE_BASE_URL}/static/10.jpg`,
        title: "患者端",
        content: "患者家属填写病情以及意向就诊医院",
        link: "/patienthome",
      },
    //   {
    //     url: `https://objectstorageapi.hzh.sealos.run/o1doc7xt-sealaf-pdwxvwwmnh-cloud-bin/Ai-image/${
    //       Math.floor(Math.random() * 18) + 1
    //     }.jpg`,
    //     title: "用药指导小助手",
    //     content:
    //       "主要针对2024版新型抗肿瘤药物临床应用指导原则,亦可通过AI模型指导普通药品",
    //     link: "https://dify.xinshu.pro/chat/QDFJF0BXpUv6LnOL",
    //   },

    //   {
    //     url: `https://objectstorageapi.hzh.sealos.run/o1doc7xt-sealaf-pdwxvwwmnh-cloud-bin/Ai-image/${
    //       Math.floor(Math.random() * 18) + 1
    //     }.jpg`,
    //     title: "报告解读、医学文档总结小助手",
    //     content: "解读医学CT、MRI、化验、病理报告等,总结医学文档等报告",
    //     link: "https://dify.xinshu.pro/chat/Mtn7mmzgIM1RBKNt",
    //   },

    ]);
    return {
      aiItems,
    };
  },
};
</script>

<style>
/* 确保所有元素都没有默认的margin和padding */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 确保html和body元素没有padding */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.app-container {
  min-height: 100vh;
  padding: 20px;
  background: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  backdrop-filter: blur(10px); /* 磨砂效果 */
}
</style>
